export class LicensePCItemArray extends Array<LicensePCItem> {

    constructor(...items: LicensePCItem[]) {
        super(...items);
        Object.setPrototypeOf(this, LicensePCItemArray.prototype);
    }

}

export class LicensePCItem {
    LicensePCID: number;
    MacAddress: string;
    Username: string;
    TargetID: string;
    IP: string;
    DateTimeCreated: Date;
    LastAttempt: Date;
    LastRegistrered: Date;
    Active: boolean;
    Available: boolean;
    DeviceID: string;
    VideoCardName: string;
    CPUName: string;
    RAM: string;
    OperatingSystem: string;
}
